export default __webpack_public_path__ + "static/media/Path 113.f3af18d7.svg";